// Open alle sub-sub-menus direct zodra ze in de DOM verschijnen
function openSubMenus() {
  document.querySelectorAll('.sub-menu-content').forEach(function (content) {
    if (content.dataset.subMenuInit) return; // al verwerkt
    content.dataset.subMenuInit = '1';
    content.hidden = false;
    content.classList.remove('sub-menu-content--closed');
    var btn = content.closest('.has-sub-menu') &&
              content.closest('.has-sub-menu').querySelector('.sub-menu-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  });
}

// Direct uitvoeren (script is defer, DOM is klaar)
openSubMenus();

// Blijf kijken voor dynamisch geladen onderdelen (bijv. mega menu custom element)
var observer = new MutationObserver(openSubMenus);
observer.observe(document.body, { childList: true, subtree: true });

// Toggle op klik
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.sub-menu-toggle');
  if (!btn) return;

  var li = btn.closest('.has-sub-menu');
  if (!li) return;
  var content = li.querySelector('.sub-menu-content');
  if (!content) return;

  var isOpen = btn.getAttribute('aria-expanded') === 'true';

  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    content.hidden = true;
    content.classList.add('sub-menu-content--closed');
  } else {
    btn.setAttribute('aria-expanded', 'true');
    content.hidden = false;
    content.classList.remove('sub-menu-content--closed');
  }
});
